import { Resources } from "./Resources";

export const SchoolResources = () => {
  return (
    <Resources blog_type="schools" />
  );
};
